import { useState, useEffect, useRef } from 'react';
import { useToast } from '../../context/ToastProvider.js';
import config from '../../constants/config.js';
import './../../styles/Modal.css';

function GemstoneVariantLinkerModal({
    isOpen,
    onUpdate,
    onClose,
    shop,
    productId,
    gemstoneId,
    gemstoneName
}) {
    const addToast = useToast();
    const [ selectedVariantId, setSelectedVariantId ] = useState( '-1' );
    const [ gemstoneVariants , setGemstoneVariants ] = useState( [] );
    const [ loadingGemstoneVariants , setloadingGemstoneVariants ] = useState( false );
    const [ uploading , setUploading ] = useState( false );
    const [ selectedRadioOption , setSelectedRadioOption ] = useState( '' );

    useEffect( () => {
        async function load() {
                setloadingGemstoneVariants( true );

                const _gemstoneVariants = await getGemstoneVariants( shop , productId );
                if ( _gemstoneVariants.length > 0 ) {
                    setGemstoneVariants( _gemstoneVariants );
                    setSelectedVariantId( _gemstoneVariants[0].id );
                    setSelectedRadioOption( "existing" );
                } else {
                    setGemstoneVariants( [] );
                    setSelectedVariantId( '-1' );
                    setSelectedRadioOption( "new" );
                }

                setloadingGemstoneVariants( false );
            }

        load();
    } , [] );

    async function getGemstoneVariants( shop , productId ) {
        let variants = [];

        try {
            const url = `${config.app.API_URL}/api/${config.app.REACT_APP_API_VERSION}/links/gemstones/variants/${encodeURIComponent( shop )}/${encodeURIComponent( productId )}`;
            const requestSettings = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                }
            };
            const response = await fetch( url , requestSettings );
            const data = await response.json();

            if ( data?.variants?.length > 0 ) {
                variants = data.variants;
            }
        } catch ( error ) {
            console.log( error );
        }

        return variants;
    }

    async function createLink( shop, productId, variantId, gemstoneId , actionType ) {
        setUploading( true );

        try {
            const payload = {
                shop: shop,
                action: actionType,
                gemstone_product_id: productId,
                gemstone_variant_id: variantId,
                gemstone_id: gemstoneId,   
            };

            const url = `${config.app.API_URL}/api/${config.app.REACT_APP_API_VERSION}/links/gemstones/variants`;
            const requestSettings = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify( payload )
            };

            const response = await fetch( url , requestSettings );
            const data = await response.json();
            if ( data?.errors?.length > 0 ) {
                addToast( `Failed to link gemstone variant - ${data?.errors[0].message}`, true , 5000 );
            } else {
                addToast( `Linked Gemstone to variant!`, false , 5000 );
            }
        } catch ( error ) {
            console.log( error );
        }

        if ( typeof onUpdate === 'function' ) {
            onUpdate();
        }

        if ( typeof onClose === 'function' ) {
            onClose();
        }

        setUploading( false );
    }

    return(
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={e => e.stopPropagation()}>
                <button className="modal-close" onClick={onClose}>
                    <span>×</span>
                    <span className="sr-only">Close modal</span>
                </button>

                <h1>Link Gemstone "{gemstoneName}" to variant</h1>
                <div className="form-group">
                    <div className="inline-radio">
                        <input
                            type="radio"
                            id="existing"
                            name="link_mode"
                            value="existing"
                            onChange={ () => {
                                setSelectedRadioOption( "existing" );
                            }}
                            disabled={ gemstoneVariants.length <= 0 || loadingGemstoneVariants }
                            checked={ selectedRadioOption === "existing" }
                        />
                        <label htmlFor="existing">Select from existing variants</label>
                    </div>
                    
                    <select 
                        id="select-gemstone-variant"
                        value={selectedVariantId} 
                        disabled={ gemstoneVariants.length <= 0 || loadingGemstoneVariants }
                        onChange={ ( e ) => { 
                            setSelectedVariantId( e.target.value ) 
                        }}
                    >
                        <option value="-1" disabled={true}>Select a variant</option>
                        { gemstoneVariants.map( ( variant , index ) => {
                            return(
                                <option key={variant.id} value={variant.id}>
                                    { variant.title }
                                </option>
                            )
                        })}
                        
                        
                    </select>

                    <div className="inline-radio">
                        <input
                            type="radio"
                            id="new"
                            name="link_mode"
                            value="new"
                            disabled={ loadingGemstoneVariants }
                            onChange={ () => {
                                setSelectedRadioOption( "new" );
                            }}
                            checked={ selectedRadioOption === "new" }
                        />
                        <label htmlFor="new">Or create a new variant</label>
                    </div>
                
                    <button 
                        disabled={ loadingGemstoneVariants || uploading }
                        className="create-link"
                        onClick={() => {
                            createLink( shop , productId , selectedVariantId , gemstoneId , selectedRadioOption );
                        }}
                    >
                        { uploading ?
                            <svg width="15" height="15" viewBox="0 0 50 50" className="spinner">
                                <circle cx="25" cy="25" r="20" stroke="white" strokeWidth="5" fill="none" strokeDasharray="90 150" strokeLinecap="round">
                                    <animateTransform attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="1s" repeatCount="indefinite" />
                                </circle>
                            </svg>
                            :
                            <span>CREATE VARIANT LINK</span>
                        }
                    </button>
                </div>
            </div>
        </div>
    )
}

export default GemstoneVariantLinkerModal;